import styled from 'styled-components'

const Style = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
`

export default Style
